import { render, staticRenderFns } from "./website.vue?vue&type=template&id=0aaf2c5f&scoped=true"
import script from "./website.vue?vue&type=script&lang=js"
export * from "./website.vue?vue&type=script&lang=js"
import style0 from "./website.vue?vue&type=style&index=0&id=0aaf2c5f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaf2c5f",
  null
  
)

export default component.exports